import React from 'react';
import { graphql } from 'gatsby';
import { gql, useQuery } from '@apollo/client';

import Layout from '../components/Layout';
import SEO from '../components/seo';
import { References } from '../components/Sections/References';
import { SleepDeprivation } from '../components/Sections/SleepDeprivation';
import { Doctors } from '../components/Sections/Doctors';
import { Promises } from '../components/Sections/Promises';
import { Testimonials } from '../components/Sections/Testimonials';
import { DeviceProducts } from '../components/Sections/DeviceProducts';
import { Hero } from '../components/Sections/Hero';
import { Donations } from '../components/Sections/Donations';

const GET_PRODUCTS = gql`
  query AllProducts {
    products(first: 10) {
      edges {
        node {
          id
          title
          handle
          productType
          variants(first: 100) {
            edges {
              node {
                id
                price
                compareAtPrice
                availableForSale
                title
              }
            }
          }
        }
      }
    }
  }
`;

function IndexPage({ data }) {
  const { data: liveProductsData, error } = useQuery(GET_PRODUCTS);
  console.log(liveProductsData, error);

  return (
    <Layout isHomepage>
      <SEO keywords={[`bluli`, `blue-light`, `screen-protectors`, `e-commerce`]} title="Home" />

      <Hero />
      <References />
      <SleepDeprivation />
      <Doctors />
      <Donations />
      <Promises />
      <Testimonials />
      <DeviceProducts
        products={data.allShopifyProduct.edges}
        liveProducts={liveProductsData ? liveProductsData.products.edges : []}
      />
    </Layout>
  );
}

export const query = graphql`
  query ShopifyProducts {
    allShopifyProduct {
      edges {
        node {
          title
          handle
          productType
          variants {
            id
            shopifyId
            price
            priceV2 {
              amount
              currencyCode
            }
            compareAtPrice
            compareAtPriceV2 {
              amount
              currencyCode
            }
            availableForSale
            title
          }
        }
      }
    }
  }
`;

export default IndexPage;
